/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function(){
  $(document).on('click','.clickerr',function(){
    $('body').addClass('activeside');
    $('.formoverlay').show('slow');
  });
  $(document).on('click','.closeside, .ProductForm__AddToCart',function(){
    $('body').removeClass('activeside');
    $('.formoverlay').hide('slow');
  });
});

const addItemToCart = async (options) => {
  let response = await fetch("/cart/add.js", options);
  let data = await response.json();
  return data;
}

document.addEventListener("DOMContentLoaded", function () {
	window.addEventListener("click", (evt) => {
		if (evt.target.classList.contains("Drawer__Upsell__Trigger")) {
			const btn = evt.target;
			addItemToCart({
				method: "post",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					items: [
						{
							quantity: 1,
							id: btn.dataset.variantId,
						},
					],
				}),
			}).then(() => {
				document.documentElement.dispatchEvent(
					new CustomEvent("cart:refresh", {
						bubbles: true,
					})
				);
			});
		}
	});
});


// Check if body has the specific class before attaching the event listener
if (document.body.classList.contains('ProductForm__AddToCart-open-popup-custom-class')) {
    document.addEventListener("product:added", (event) => {
        // Perform actions with event.detail.variant and event.detail.quantity
        var $cartContainer = $('#sidebar-cart');
        var $Pageoverlay = $('.PageOverlay');
        
        // Use event delegation to attach the click event to dynamically created buttons
        // Perform your custom actions here
        console.log('Custom logic before cart opens');
        
        // Example: Show the cart manually
        $cartContainer.hide();
        $Pageoverlay.removeClass('is-visible');
        $(".gift-box-popup-window-wrapper").css("display", "flex");
    });
}



// $(document).ready(function() {
//     // Select the cart container and page overlay
//     var $cartContainer = $('#sidebar-cart');
//     var $Pageoverlay = $('.PageOverlay');
    
//     // Use event delegation to attach the click event to dynamically created buttons
//     $(document).on('click', '.ProductForm__AddToCart-open-popup-custom-class button[data-action="add-to-cart"]', function(event) {
//         // Perform your custom actions here
//         console.log('Custom logic before cart opens');
        
//         // Example: Show the cart manually
//         $cartContainer.hide();
//         $Pageoverlay.removeClass('is-visible');
//         $(".gift-box-popup-window-wrapper").css("display", "flex");
//     });
// });

$(".gift-box-popup-window-wrapper .product-gift-close-btn").click(function(){
	$(".gift-box-popup-window-wrapper").hide(500);
	$(".PageOverlay").removeClass("is-visible");
})


$(document).ready(function () {
	const parentOptions = $('input[name="parent-option"]');
	const childOptions = $('.child-option');
	const addToCartButton = $('#add-to-cart');

	// Function to update child options based on parent selection
	function updateChildOptions(parentValue) {
		childOptions.each(function () {
			const $child = $(this);
			if ($child.data('parent') === parentValue) {
				$child.show();
			} else {
				$child.hide();
			}
		});

		// Automatically select the first available child option
		const visibleChildren = $(`.child-option[data-parent="${parentValue}"]`);
		const firstVisibleChild = visibleChildren
			.filter(function () {
				return !$(this).find('input').prop('disabled');
			})
			.first();

		if (firstVisibleChild.length) {
			firstVisibleChild.find('input').prop('checked', true);
		}
	}

	// Initial load: Update child options based on the default parent option
	const defaultParent = $('input[name="parent-option"]:checked');
	if (defaultParent.length) {
		updateChildOptions(defaultParent.val());
	}

	// Update child options when parent option changes
	parentOptions.on('change', function () {
		updateChildOptions($(this).val());
	});

	// Handle Add to Cart
	addToCartButton.on('click', function () {
		$(".gift-box-popup-window-wrapper .product-form .custom-select-box-block .errro-msg").hide();
		const selectedChild = $('input[name="child-option"]:checked');
		if (selectedChild.length) {
			const variantId = selectedChild.val();
			const selectedMonth = $(".gift-box-popup-window-wrapper .product-form .custom-select-box-block .custom-select-box").val();
			if (selectedMonth !== "") {
				console.log(selectedMonth);
				// Add to cart request
				const formAction = `/cart/add.js`;
				$.ajax({
					url: formAction,
					type: 'POST',
					contentType: 'application/json',
					data: JSON.stringify({
						id: variantId,
						quantity: 1,
						properties:{
							"Number of Dics": 1,
							"Pendant #1": selectedMonth
						}
					}),
					success: function (data) {
						// document.documentElement.dispatchEvent(
						// 	new CustomEvent("cart:refresh", {
						// 		bubbles: true,
						// 	})
						// );
						location.href = '/cart';
						console.log(data);
					},
					error: function (error) {
						console.error('Error:', error);
					},
				});
			} else {
				$(".gift-box-popup-window-wrapper .product-form .custom-select-box-block .errro-msg").show();
			}
		} else {
			alert('Please select a variant!');
		}
	});
});


